const route = $("body").data('route');

export default route;